import { render } from "./SidebarStats.vue?vue&type=template&id=655a6ccf&scoped=true"
import script from "./SidebarStats.vue?vue&type=script&lang=js"
export * from "./SidebarStats.vue?vue&type=script&lang=js"

import "./SidebarStats.vue?vue&type=style&index=0&id=655a6ccf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-655a6ccf"]])

export default __exports__